// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link_Link__R5_zq","HasLink":"Link_HasLink__QBSB1"};